import {inject, Injectable} from "@angular/core";
import {DaoGeneric} from "@Services/base/daoService";
import {environment} from "@Env/environment";
import {HttpClient} from "@angular/common/http";
import {ResponseAvisHistoric} from "./response-avis-historic.model";
import {ResponseAvisService} from "./response-avis.service";

@Injectable({providedIn: 'root'})
export class ResponseAvisHistoricService extends DaoGeneric<ResponseAvisHistoric> {
  private _api = `${environment.baseUrl}/demat/responseavishistoric/`;
  private responseAvisSvc = inject(ResponseAvisService);

  constructor(private httpClient: HttpClient) {
    super(httpClient);
  }

  getRootUrl(urlApp: string | undefined): string {
    return this._api;
  }
  getChipAvis(avis: ResponseAvisHistoric) {
    const stateLabel = this.responseAvisSvc.labelAvis(avis.avis);
    const classType = this.responseAvisSvc.classAvis(avis.avis);
    return `<small><span class="state-demat-avis-chip ${classType}">${stateLabel}</span></small>`;
  }
}
